import React from "react";
import "./shimmerLoader.css";

const ShimmerLoader = ({ width = "95%", height = "20%", count = 4 }) => {
  const shimmerItems = Array.from({ length: count }, (_, index) => (
    <div className='shimmer' key={index} style={{ width, height }}>
      <div className='wrapper'>
        <div className='stroke animate title'></div>
        <div className='stroke animate link'></div>
        <div className='stroke animate description'></div>
      </div>
    </div>
  ));

  return <>{shimmerItems}</>;
};

export default ShimmerLoader;
